import FeedbackWrapper from './FeedbackWrapper';

export default FeedbackWrapper;
